// components/connection-alert/connection-alert.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConnectionService } from '../../../core/services/connectivity/connection.service';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-connection-alert',
  template: `
    <div *ngIf="!isOnline" class="alert-container">
      <div class="alert-content">
        <i class="material-icons">wifi_off</i>
        <span
          >You are currently offline. Please check your internet
          connection.</span
        >
      </div>
    </div>
  `,
  styles: [
    `
      .alert-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background-color: #f44336;
        color: white;
        padding: 1rem;
        z-index: 1000;
        animation: slideDown 0.3s ease-out;
      }

      .alert-content {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
      }

      @keyframes slideDown {
        from {
          transform: translateY(-100%);
        }
        to {
          transform: translateY(0);
        }
      }
    `,
  ],
})
export class ConnectionAlertComponent implements OnInit, OnDestroy {
  isOnline = true;
  private subscription: Subscription;
  constructor(@Inject(ConnectionService) private connectionService: ConnectionService) {}
  // constructor(private connectionService: ConnectionService) {}

  ngOnInit() {
    this.subscription = this.connectionService.online$.subscribe(
      (online) => (this.isOnline = online)
    );
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
